import { render } from "./guitar.vue?vue&type=template&id=512e4a78"
import script from "./guitar.vue?vue&type=script&lang=js"
export * from "./guitar.vue?vue&type=script&lang=js"
script.render = render

export default script